import React, { useEffect } from 'react';
import { useToast } from './ToastProvider';
import { setToastState } from '../../../utils/toast';

/**
 * This component initializes the toast state for the toast utility.
 * It should be rendered once at the top level of the application.
 */
const ToastInitializer: React.FC = () => {
  const toast = useToast();

  useEffect(() => {
    // Set the toast state for the toast utility
    setToastState(toast);
    
    // Clean up when the component unmounts
    return () => {
      setToastState(null as unknown as typeof toast);
    };
  }, [toast]);

  // This component doesn't render anything
  return null;
};

export default ToastInitializer;